import { render } from "./register.vue?vue&type=template&id=b27e4ebc"
import script from "./register.vue?vue&type=script&lang=js"
export * from "./register.vue?vue&type=script&lang=js"

import "./register.vue?vue&type=style&index=0&id=b27e4ebc&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanrenrenxing\\guifanrenrenxing-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__